<template>
    <div>
        <rkm-form
            ref="Form"
            show-legend
        >
            <rkm-row class="flex-nowrap">
                <rkm-col class="flex-grow-1">
                    <rkm-form-select
                        label="Setor"
                        :options="form.setores"
                        :validations="validations.setor"
                        v-model="centroCusto.setorId"
                        value-field="id"
                        text-field="nome"
                        show-default-option
                    >
                        <rkm-input-group-append slot="append">
                            <rkm-button
                                @click.stop="$refs.ModalSetor.open()"
                                color="primary"
                                title="Cadastrar setor"
                            >
                                <rkm-icon icon="plus" />
                            </rkm-button>
                        </rkm-input-group-append>
                    </rkm-form-select>
                </rkm-col>

                <rkm-col class="flex-grow-0 text-nowrap">
                    <rkm-button
                        :label="false"
                        color="primary"
                        @click.stop="$refs.Form.validate(add)"
                    >
                        Incluir
                    </rkm-button>
                </rkm-col>
            </rkm-row>
        </rkm-form>

        <rkm-table
            :fields="fields"
            :items="infraestrutura.centrosCusto"
        >
            <template v-slot:cell(actions)="row">
                <rkm-button
                    color="primary"
                    title="Cadastrar salas"
                    small
                    @click.stop="$refs.ModalSala.open(infraestrutura, row.item)"
                >
                    <rkm-icon icon="door-open" />
                </rkm-button>

                <rkm-button
                    color="danger"
                    title="Excluir"
                    small
                    @click.stop="handleDestroy(row)"
                >
                    <rkm-icon icon="trash" />
                </rkm-button>
            </template>
        </rkm-table>

        <ModalSetor
            ref="ModalSetor"
            @save="refreshSetores"
        />

        <ModalSala ref="ModalSala" />
    </div>
</template>

<script>
// Components.
import ModalSetor from '@/components/cadastro/setor/Modal'
import ModalSala from '@/components/cadastro/sala/Modal'

// Vuex.
import { mapActions } from 'vuex'

// Mixins.
import { repository, error, object } from '@/mixins'

export default {
    components: { ModalSetor, ModalSala },
    mixins: [ repository, error, object ],
    props: {
        infraestrutura: { type: Object, required: true },
    },
    data: () => ({
        repositories: {
            setor: null,
        },
        form: {
            setores: [],
        },
        centroCusto: {
            id: null,
            setorId: null,
            setorNome: '',
            salas: [],
        },
        fields: [
            {
                key: 'setorNome',
                label: 'Setor',
                sortable: true,
            },
            {
                key: 'actions',
                label: 'Ações',
                class: 'col-min'
            },
        ],
    }),
    computed: {
        validations() {

            return {
                setor: { required: true },
            }
        },
    },
    methods: {
        ...mapActions(['setLoading', 'unsetLoading']),
        load(callback) {

            this.setLoading()

            this.repositories.setor.index()
                .then(({ data }) => {

                    this.form.setores = data

                    if (typeof callback === 'function') {

                        callback()
                    }
                })
                .catch(this.handleError)
                .finally(() => this.unsetLoading())
        },
        add() {

            this.validateDuplicity()
                .then(valid => {

                    if (!valid) return

                    const centroCusto = this.clone(this.centroCusto)

                    centroCusto.setorNome = this.form.setores.find(s => s.id === centroCusto.setorId).nome

                    this.infraestrutura.centrosCusto.push(centroCusto)

                    this.resetForm()
                })
        },
        async validateDuplicity() {

            const hasSetor = this.infraestrutura.centrosCusto
                .find(cc => cc.setorId === this.centroCusto.setorId)

            if (hasSetor) {

                this.showValidationNotification('O centro de custo já existe.')

                return false
            }

            return true
        },
        resetForm() {

            this.centroCusto.id = null
            this.centroCusto.setorId = null
            this.centroCusto.setorNome = ''
            this.centroCusto.salas = []

            this.$nextTick(() => this.$refs.Form.resetValidator())
        },
        handleDestroy({ index }) {

            const destroy = async () => this.infraestrutura.centrosCusto.splice(index, 1)

            this.showDeleteConfirmation('Deseja realmente excluir o centro de custo?', destroy)
        },
        refreshSetores(setor) {

            this.load(() => this.centroCusto.setorId = setor.id)
        },
    },
    created() {

        this.repositories.setor = this.getConectaSusRepository('cadastro.estabelecimento.setor')
    },
}
</script>